import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import * as moment from 'moment';
import { IUpdateCRsDialogData } from 'src/app/shared/interfaces/update-crs-dialog-data.interface';
import { CalculationResultService } from '../../../services/calculation-result.service';

@Component({
    standalone: false,
    selector: 'app-set-zc-version-properties-dialog',
    templateUrl: './set-zc-version-properties-dialog.component.html',
    styleUrls: ['./set-zc-version-properties-dialog.component.scss']
})
export class SetZcVersionPropertiesDialogComponent implements OnInit {
    lastUpdated: any;
    error: boolean = false;
    showSpinner: boolean = false;

    constructor(
        @Inject(MAT_DIALOG_DATA) public data: IUpdateCRsDialogData,
        private readonly crService: CalculationResultService,
        public dialogRef: MatDialogRef<SetZcVersionPropertiesDialogComponent>
    ) {}

    get canSave(): boolean {
        return !this.showSpinner && this.lastUpdated;
    }

    ngOnInit(): void {
        this.lastUpdated = moment
            .utc()
            .startOf('hour')
            .format('yyyy-MM-DDTHH:mm');
    }

    setLastUpdated() {
        this.error = false;
        this.showSpinner = true;
        const lastUpdated = moment.utc(this.lastUpdated).toISOString();
        this.crService.updateCRs(this.data.stateEnv, this.data.zcVersionId, lastUpdated).subscribe(
            _data => {
                this.showSpinner = false;
                this.dialogRef.close(true);
            },
            err => {
                console.log('SetZcVersionPropertiesDialogComponent.setLastUpdated => ERROR:');
                console.log(err);
                this.error = true;
                this.showSpinner = false;
            }
        );
    }

    closePopup() {
        this.dialogRef.close(false);
    }
}
